export const button = {
    search: 'search',
    confirm: 'confirm',
    ok: 'ok',
    cancel: 'cancel',
    close: 'close'
}